import { render, staticRenderFns } from "./CustomerOrder.vue?vue&type=template&id=7559b514&"
import script from "./CustomerOrder.vue?vue&type=script&lang=ts&"
export * from "./CustomerOrder.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerOrder.vue?vue&type=style&index=0&id=7559b514&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports